import React from "react";
import { Dialog } from "@mui/material";
import { useModalClasses } from "./Modal.style.js";
import { ModalContent } from "./ModalContent.js";
import { ModalContext } from "./types.js";
const Modal = () => {
  const { classes: modalClasses } = useModalClasses();
  const { isModalOpened, modalContent, closeModal } = React.useContext(ModalContext);
  const dialogClasses = {
    paper: `${modalContent?.styleParams?.isLimitedBody ? modalClasses.modalDialogLimited : ""}`
  };
  function handleClose() {
    if (modalContent?.onClose) {
      modalContent.onClose();
    }
    closeModal();
  }
  return /* @__PURE__ */ React.createElement(
    Dialog,
    {
      classes: dialogClasses,
      open: isModalOpened,
      onClose: handleClose,
      scroll: "paper",
      maxWidth: modalContent?.styleParams?.maxWidth ?? "sm",
      fullWidth: true,
      "data-testid": "modal"
    },
    /* @__PURE__ */ React.createElement(ModalContent, { ...{ ...modalContent, onCloseClick: handleClose } })
  );
};
export {
  Modal
};
//# sourceMappingURL=Modal.js.map
